import { Controller } from '@hotwired/stimulus'

// One termination line in the Request Termination modal: the date fields are
// live only while the service is ticked, so unticked services submit nothing
// and the required termination date only binds to lines that actually end.
export default class extends Controller {
  static targets = ['toggle', 'field']

  connect() {
    this.sync()
  }

  sync() {
    const on = this.toggleTarget.checked
    this.fieldTargets.forEach((field) => {
      field.disabled = !on
      if (field.dataset.requiredWhenEnabled === 'true') field.required = on
    })
  }
}
